<template>
  <div class="app-user">
    <section class="top-wrap">
      <div class="main-title">应用成员</div>
      <div class="right">
        <div class="mRight10">
          <el-input
            v-model="userSearchValue"
            size="small"
            placeholder="请输入搜索内容"
            @keyup.enter.native.stop="receiveUserSearchValue"
            clearable
          >
            <el-select
              v-model="userSearchKey"
              @change="userSearchValue = ''"
              slot="prepend"
              placeholder="请选择"
              style="width: 100px"
            >
              <el-option label="姓名" value="name"></el-option>
              <el-option label="手机号" value="telephone"></el-option>
              <el-option label="角色" value="role"></el-option>
            </el-select>
            <el-button
              slot="append"
              size="small"
              icon="el-icon-search"
              @click="receiveUserSearchValue"
            ></el-button>
          </el-input>
        </div>
        <base-button type="primary" @click="addUser">添加成员</base-button>
      </div>
    </section>
    <section class="main-wrap">
      <div v-if="!showTable" v-loading="!showTable" class="empty"></div>
      <BaseTable
        v-else
        ref="BaseTable"
        :tableHeight="tableHeight"
        :tableColumns="tableColumns"
        :tableData="filterUsers"
        :pageInfo="pageInfo"
        from="app"
      >
        <template v-slot:table-suffix>
          <el-table-column prop="handle" label="操作" width="160">
            <template v-slot="scope">
              <el-button @click.stop="edit(scope.row)" type="text" size="mini">
                编辑
              </el-button>
              <el-button @click.stop="scram(scope.row)" type="text" size="mini">
                移出应用
              </el-button>
            </template>
          </el-table-column>
        </template>
      </BaseTable>
    </section>
    <base-dialog :show-close="true" :visible.sync="addUserDialogVisible">
      <template v-slot:header>{{ dialogHeader }}</template>
      <el-form ref="form" :model="addUserForm" label-width="80px" :rules="rules">
        <el-form-item label="用户" prop="userIds">
          <user-selector
            :disabled="isEdit"
            v-model="addUserForm.userIds"
            multiple
            status-normal
          ></user-selector>
        </el-form-item>
        <el-form-item label="角色" prop="roleIds">
          <el-select v-model="addUserForm.roleIds" multiple filterable placeholder="请选择角色">
            <el-option
              v-for="item in roles"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template v-slot:footer>
        <span class="dialog-footer">
          <base-button @click="addUserDialogVisible = false">取消</base-button>
          <base-button type="primary" @click="addUsersToApp('form')">确认</base-button>
        </span>
      </template>
    </base-dialog>
  </div>
</template>

<script>
import BaseTable from "@/components/BaseComponents/Table"
import BaseButton from "@/components/UIComponents/Button"
import BaseDialog from "@/components/BaseComponents/Dialog"
import { tableColumns } from "./static"
import TableController from "@/views/Backend/Admin/Layout/mixin/TableController"
import * as roleApi from "@/api/appManage/role"
import * as userApi from "@/api/appManage/user"
import UserSelector from "@/components/FormControl/UserSelector"
import { getAppUsers } from "@/api/user"
import { getDepartment, initUserData } from "@/utils/user"
import { deepClone } from "@/utils/common"

export default {
  name: "AppUser",
  components: {
    BaseTable,
    BaseButton,
    BaseDialog,
    UserSelector
  },
  inject: ["app"],
  data() {
    return {
      tableColumns,
      telephone: "",
      users: [],
      roles: [],
      userSearchKey: "name",
      userSearchValue: "",
      userSearchFlag: false,
      pageInfo: {
        total: 1000,
        currentPage: 1,
        pageSize: 20
      },
      loadingItems: {
        data: true
      },
      addUserDialogVisible: false,
      addUserForm: {
        userIds: [],
        roleIds: []
      },
      rules: {
        userIds: [{ required: true, message: "请选择用户", trigger: "blur" }],
        roleIds: [{ required: true, message: "请选择角色", trigger: "blur" }]
      },
      isEdit: false
    }
  },
  watch: {
    // 监听用户列表搜索文字是否变成空值
    userSearchValue: function(newVal) {
      if (!newVal || newVal == "") this.userSearchFlag = false
    }
  },
  mixins: [TableController],
  created() {
    this.refresh()
  },
  computed: {
    // 经过筛选后的用户列表
    filterUsers() {
      let users = this.users
      if (this.userSearchFlag) {
        users = users.filter(i => {
          switch (this.userSearchKey) {
            case "name": {
              return i.name.includes(this.userSearchValue)
            }
            case "telephone": {
              return i.telephone.includes(this.userSearchValue)
            }
            case "role": {
              return i.role.includes(this.userSearchValue)
            }
          }
        })
      }
      this.resetPageInfo(users)
      return users
    },
    dialogHeader() {
      return this.isEdit ? "编辑权限" : "添加成员"
    },
    roleMap() {
      return this._.keyBy(this.roles, "id")
    }
  },
  methods: {
    async refresh() {
      this.loadingItems.data = true
      await initUserData(this.app.id)
      this.roles = await roleApi.getRoles({ appId: this.app.id, cache: false })
      Promise.all([
        getAppUsers({ appId: this.app.id, cache: false }).then(data => {
          this.users = data
            .filter(d => this._.isObject(d))
            .map(item => {
              let result = deepClone(item)
              result.department = getDepartment(item.companyScope?.departmentIds[0])?.name
              let role = ""
              item.roleIds.forEach(
                (roleId, index) =>
                  (role = role + (index === 0 ? "" : "，") + this.roleMap[roleId]?.name)
              )
              result.role = role
              return result
            })
        })
      ]).finally(() => (this.loadingItems.data = false))
    },
    addUser() {
      this.addUserForm = this.$options.data().addUserForm
      this.addUserDialogVisible = true
      this.isEdit = false
    },
    edit(row) {
      this.addUserDialogVisible = true
      this.isEdit = true
      this.addUserForm.userIds = [row.id]
      this.addUserForm.roleIds = row.roleIds
    },
    scram(row) {
      this.$confirm("此操作将从应用中移除该员工, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        userApi.removeAppUser(row.id, this.app.id).then(() => {
          this.$message.success("移除成功")
          this.getUsers()
        })
      })
    },
    // 用户列表搜索文字提交
    receiveUserSearchValue() {
      if (!this.userSearchValue) {
        this.$message.warning("请输入搜索内容")
        return
      }
      this.userSearchFlag = true
    },
    getUsers() {
      this.loadingItems.data = true
      return getAppUsers({ appId: this.app.id, cache: false })
        .then(
          res =>
            (this.users = res
              .filter(d => this._.isObject(d))
              .map(item => {
                let result = deepClone(item)
                result.department = getDepartment(item.companyScope?.departmentIds[0])?.name
                let role = ""
                item.roleIds.forEach(
                  (roleId, index) =>
                    (role = role + (index === 0 ? "" : "，") + this.roleMap[roleId]?.name)
                )
                result.role = role
                return result
              }))
        )
        .finally(() => (this.loadingItems.data = false))
    },
    addUsersToApp(ref) {
      this.$refs[ref].validate(valid => {
        if (valid) {
          if (this.isEdit) {
            userApi
              .editUserRole(this.addUserForm.userIds[0], this.addUserForm.roleIds, this.app.id)
              .then(() => {
                this.$message.success("修改成功")
                this.addUserDialogVisible = false
                this.refresh()
              })
          } else {
            userApi
              .addUsersToApp(this.addUserForm.userIds, this.addUserForm.roleIds, this.app.id)
              .then(() => {
                this.$message.success("操作成功")
                this.addUserDialogVisible = false
                this.refresh()
              })
          }
        } else {
          this.$message.error("用户和角色必填")
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-user {
  .top-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .right ::v-deep {
      display: flex;
      margin-left: auto;
      .el-input {
        margin-right: 10px;
      }
    }
  }
}
.el-form {
  padding: 22px 14px 8px;
  ::v-deep {
    .el-form-item__content > .el-select {
      width: 100%;
    }
  }
}
</style>
